import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useProjectStore } from 'Store/Project'
import { useAuthStore } from 'Store/Auth'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'
import CustomActionCell from 'Presentation/Components/Table/Components/CustomActionCell'
import { shallow } from 'zustand/shallow'

const ViewModel = () => {
  const { id } = useParams<{ id: string }>()
  const { sales, data, getOne, getSaleUsers, assignSaleUser, removeSaleUser } = useProjectStore(
    state => ({
      sales: state.availableSaleUsers,
      data: state.selected,
      getOne: state.getOne,
      getSaleUsers: state.getAvailableSaleUsers,
      assignSaleUser: state.assignSaleUser,
      removeSaleUser: state.unassignSaleUser,
    })
  )
  const { profile } = useAuthStore(state => ({ profile: state.profile }), shallow)

  const userRoleId = profile?.roleId || 0

  const fetchData = () => {
    getSaleUsers()
  }

  const onAssignSaleUser = async () => {
    Swal.fire({
      title: 'เพิ่มฝ่ายขาย (Sale User)',
      input: 'select',
      inputOptions: sales.reduce((options, user) => {
        options[user.id] = user.fullName
        return options
      }, {} as Record<number, string>),
      inputPlaceholder: 'เลือกฝ่ายขาย (Sale User)',
      showCancelButton: true,
      inputValidator: value => {
        return new Promise(resolve => {
          if (value) {
            resolve('')
          } else {
            resolve('กรุณาเลือกฝ่ายขาย (Sale User)')
          }
        })
      },
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const formData = new FormData()
          formData.append('saleUserId', result.value)
          const { success, data } = await assignSaleUser(parseInt(id ?? ''), formData)
          if (success) {
            toast.success('เพิ่มฝ่ายขาย (Sale User) สำเร็จ')
            getOne(parseInt(id ?? ''))
          } else {
            toast.error(data?.message || data || 'เพิ่มฝ่ายขาย (Sale User) ไม่สำเร็จ')
          }
        } catch (error) {
          toast.error('เพิ่มฝ่ายขาย (Sale User) ไม่สำเร็จ')
        }
      }
    })
  }

  const onRemoveSaleUser = async (userId: number) => {
    Swal.fire({
      title: 'คุณต้องการลบฝ่ายขาย (Sale User) ใช่หรือไม่?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const formData = new FormData()
          formData.append('saleUserId', userId.toString())
          const { success, data } = await removeSaleUser(parseInt(id ?? ''), formData)
          if (success) {
            toast.success('ลบฝ่ายขาย (Sale User) สำเร็จ')
            getOne(parseInt(id ?? ''))
          } else {
            toast.error(data?.message || data || 'ลบฝ่ายขาย (Sale User) ไม่สำเร็จ')
          }
        } catch (error) {
          toast.error('ลบฝ่ายขาย (Sale User) ไม่สำเร็จ')
        }
      }
    })
  }

  const columns: any[] = [
    {
      Header: 'ชื่อ-นามสกุล',
      accessor: 'fullName',
      width: 200,
      minWidth: 200,
      disableSortBy: true,
      Cell: ({ value }: any) => <span className='text-gray-800'>{value}</span>,
    },
    {
      Header: 'อีเมล',
      accessor: 'username',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    // {
    //   Header: 'ตำแหน่ง',
    //   accessor: 'roleTitle',
    //   width: 200,
    //   minWidth: 200,
    //   Cell: ({ row }: any) => {
    //     return <span className='text-gray-800'>{row.original.supervisor.roleTitle ?? '-'}</span>
    //   },
    // },
    {
      Header: '',
      accessor: 'action',
      width: 100,
      minWidth: 100,
      Cell: ({ row }: any) => (
        <CustomActionCell
          id={row.original.id}
          hideView
          hideEdit
          hideDuplicate
          onClickDelete={() => {
            onRemoveSaleUser(row.original.saleUserId)
          }}
        />
      ),
    },
  ]

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    userRoleId,
    data: data?.saleUsers ?? [],
    columns,
    sales,
    onAssignSaleUser,
    onRemoveSaleUser,
  }
}

export default ViewModel
